<template>
  <div class="layout-app">
    <Header />
    <div class="layout-body">
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue';
import api from './api';

export default {
  components: { Header },
  data() {
    return {
      inactivityTimer: null,
      inactivityLimit: 5 * 60 * 1000, // 5 minutos
    };
  },
  mounted() {
    this.startInactivityTimer();
    this.addActivityListeners();
  },
  beforeUnmount() {
    this.removeActivityListeners();
    if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
  },
  methods: {
    startInactivityTimer() {
      if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(this.forceLogout, this.inactivityLimit);
    },
    resetInactivityTimer() {
      this.startInactivityTimer();
    },
    async forceLogout() {
      try {
        await api.post('/logout-forzado');
      } catch (e) {
        // Ignorar errores, continuar con logout local
      }
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_name');
      localStorage.removeItem('user_role');
      window.location.replace('/ticketagrovin/login');
    },
    addActivityListeners() {
      const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
      events.forEach(event => {
        window.addEventListener(event, this.resetInactivityTimer, true);
      });
    },
    removeActivityListeners() {
      const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
      events.forEach(event => {
        window.removeEventListener(event, this.resetInactivityTimer, true);
      });
    },
  },
};
</script>

<style>
.layout-app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.layout-body {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
}
</style>
